import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
    
    window.open('https://okalone.zendesk.com/hc/en-gb?utm_source=dashboard&utm_medium=dashboard&utm_campaign=dashboard');
    this.router.navigateByUrl('/home');

  }

}
